export enum Links {
    LINK_DOCS_TERMS_BNS = '/files/dokumenty/2024/10/doc/regulamin_respect_bonus_na_start.pdf',
}
